import React, { forwardRef } from 'react';
import { useHeading } from './HeadingProvider';

import type { HTMLAttributes } from 'react';
import { tildeToSoftHyphen } from '~utils/string';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  /**
   * - If used inside a `HeadingProvider`, the level prop is calculated relative to the base level defined in the provider.
   * - If used standalone, apply the level prop as an absolute value.
   */
  level?: HeadingLevel;
  /** Force-applies the level prop as an absolute value even if the component is used inside a `HeadingProvider`. */
  force?: boolean;
};

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ level = 1, force = false, children, ...props }, ref) => {
    const { baseLevel } = useHeading();

    const tagLevel: HeadingLevel = baseLevel && !force ? (Math.min(baseLevel + level - 1, 6) as HeadingLevel) : level;

    return React.createElement(
      `h${tagLevel}`,
      { ...props, ref },
      typeof children === 'string' ? tildeToSoftHyphen(children) : children,
    );
  },
);
